module.exports = __webpack_public_path__ + "img/4_3.bfd250e0.jpg";